<script>
import {CorporateTransactionInitForm} from "../controllers/transaction.init.form";
import {systems} from "../../../core/data/global";
import {CorporateLayout} from "../controllers/dashboard.layout";
import axios from "axios";
import vSelect from "vue-select";

export default {
    name: "CorporateTransactionInitForm",
    computed: {
        systems() {
            return systems;
        },
        canBuyEconetZwg() {
            return this.user.corporate.name === 'Fanset International'
                || Number(this.user.corporate.id) === 3;
        }
    },
    components: {
        PhoneInput: () => import('../../../components/custom/phone-input.vue'),
        vSelect
    },
    mixins: [CorporateTransactionInitForm, CorporateLayout],

    data() {
        return {
            accountTypeFromUrl: '',
            accountNumberFromUrl: '',
            storedAccounts: [],
            selectedStoredAccountZesa: null,
            selectedStoredAccountAirtime: null,
            selectedStoredAccountBundle: null,
            selectedStoredAccountNetone: null,
            selectedStoredAccountEcoUSD: null,
            selectedStoredAccountEcoUSDBundle: null,
        };
    },

    mounted() {
        this.prefillTransaction();
        this.fetchStoredAccounts();
    },

    methods: {
        fetchStoredAccounts() {
            axios.get('/business/business-stored-accounts')
                .then(response => {
                    this.storedAccounts = response.data.body.accounts;
                })
                .catch(error => {
                    console.error("Error fetching stored accounts:", error);
                });
        },

        prefillTransaction() {
            let { account_name, group_name, account_type, account_number, contact_info } = this.$route.params;

            if (account_type  === "ZESA") {
                this.form.zesa.push({
                    account: account_name,
                    group: group_name,
                    meter: account_number,
                    phone: contact_info || '',
                    amount: ''
                });
            } else if (account_type === "ECONET") {
                this.form.airtime.push({
                    account: account_name,
                    group: group_name,
                    phone: account_number,
                    amount: ''
                });
            } else if (account_type  === "NETONE") {
                this.form.bundle.push({
                    account: account_name,
                    group: group_name,
                    phone: account_number,
                    bundle: '',
                    amount: ''
                });
            }
        },

        populateFromStoredAccount() {
            if (this.selectedStoredAccountZesa) {
                let account = this.selectedStoredAccountZesa;
                if (account.account_type === "ZESA") {
                    this.form.zesa.push({
                        account: account.account_name,
                        group: account.group_name,
                        meter: account.account_number,
                        phone: account.contact_info || '',
                        amount: '',
                    });
                    this.selectedStoredAccountZesa = '';
                }
            }

            if (this.selectedStoredAccountAirtime) {
                let account = this.selectedStoredAccountAirtime;
                if (account.account_type === "ECONET") {
                    this.form.airtime.push({
                        account: account.account_name,
                        group: account.group_name,
                        phone: account.account_number,
                        amount: '',
                    });
                }
                this.selectedStoredAccountAirtime = '';
            }

            if (this.selectedStoredAccountEcoUSD) {
                let account= this.selectedStoredAccountEcoUSD;
                if (account.account_type === "ECONET") {
                    this.form.airtimeEco.push({
                        account: account.account_name,
                        group: account.group_name,
                        phone: account.account_number,
                        bundle: '',
                        amount: '',
                    });
                    this.selectedStoredAccountEcoUSD = '';
                }
            }

            if (this.selectedStoredAccountBundle) {
                console.log(this.selectedStoredAccountBundle);
                let account = this.selectedStoredAccountBundle;
                if (account.account_type === "ECONET") {
                    this.form.bundle.push({
                        account: account.account_name,
                        group: account.group_name,
                        phone: account.account_number,
                        bundle: '',
                        amount: '',
                    });
                    this.selectedStoredAccountBundle = '';
                }
            }

            if (this.selectedStoredAccountEcoUSDBundle) {
                console.log(this.selectedStoredAccountEcoUSDBundle);
                let account = this.selectedStoredAccountEcoUSDBundle;
                if (account.account_type === "ECONET") {
                    this.form.smart.push({
                        account: account.account_name,
                        group: account.group_name,
                        phone: account.account_number,
                        bundle: '',
                        amount: '',
                    });
                    this.selectedStoredAccountEcoUSDBundle = '';
                }
            }

            if (this.selectedStoredAccountNetone) {
                let account = this.selectedStoredAccountNetone;
                if (account.account_type === "NETONE") {
                    this.form.netone.push({
                        account: account.account_name,
                        group: account.group_name,
                        phone: account.account_number,
                        bundle: '',
                        amount: '',
                    });
                    this.selectedStoredAccountNetone = '';
                }
            }
        }


    }
}
</script>



<template>
    <div class="text-left bg-white shadow-sm rounded-lg overflow-hidden">
        <div class="card-body border-bottom">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h5 class="font-weight-400 d-inline-block mb-0">
                        {{ $route.query.copy ? 'Reprocess Previous Transaction' : 'Create Transaction' }}
                    </h5>

                </div>
                <div class="text-5 font-weight-bold" v-if="batchTotal">
                    {{ methods[form.payment] }}
                    {{ batchTotal }}
                </div>
            </div>
            <p v-if="isCopiedTransaction" class="mb-0">
                Source #{{ $route.query.copy }}
            </p>
        </div>

        <!-- Spinner loader -->
        <div v-if="loading" class="text-center m-5">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div class="card-body border-bottom">
            <div class="form-group">
                <label> Pay with </label>
                <select @change="ccurrency" required v-model="form.payment"
                        :class="[ 'custom-select' , form.errors.get('payment') ? 'is-invalid' : '' ]">
                    <option value="">Choose Payment Method</option>
                    <option value="wallet">Magetsi Wallet ZWG</option>
                    <option value="wallet-usd">Magetsi Wallet USD</option>
                </select>
                <div v-text="form.errors.get('payment')" class="invalid-feedback"/>
            </div>
            <div v-if="form.payment === 'ecocash' || form.payment === 'ecocash-usd' " class="form-group">
                <label>EcoCash Phone Number</label>
                <phone-input v-model="form.ecocash" required
                             :class="[ form.errors.get('ecocash') ? 'is-invalid' : '' ]"
                             placeholder="EcoCash Phone Number"/>
            </div>
            <div v-else class="form-group">
                <label>Email</label>
                <input type="email" v-model="form.email" value="email"
                       required
                       :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                       placeholder="Email">
                <div v-text="form.errors.get('email')" class="invalid-feedback"/>
            </div>
        </div>

        <div v-if="isCopiedTransaction" class="bg-primary px-4 py-3 text-white">
            <i class="fa fa-star mr-1"></i>
            You can edit, delete or add new transactions before submitting
        </div>

        <!-- ZESA ============================-->
        <div class="card-body border-bottom">
            <div class="d-flex align-items-center" :class="{ 'mb-3': form.zesa.length }">
                <div class="mr-auto text-4">
                    ZESA Tokens
                </div>
                <div class="alert alert-danger">
                    <strong>NOTE:</strong> The Zesa Limit per meter is USD 500 or the ZWG equivalent.
                </div>
                <div>
                    <div v-if="!systems.corp_zesa" class="bg-danger rounded text-white text-center text-1 mt-n1 px-2">
                        <strong>NOTE:</strong> {{ 'This service is unavailable at the moment. Please try again later.' }}
                    </div>
                    <button v-else @click="form.zesa.push({meter : '', phone : '', amount : ''})"
                            class="btn btn-success shadow-none btn-sm btn-extra-small mx-1">
                        <i class="fa fa-plus-circle"></i>
                        <small>Add Row</small>
                    </button>

                </div>
            </div>

            <div class="form-group" v-if="systems.corp_zesa">
                <label>Select Stored Account (ZESA)</label>
                <v-select
                    v-model="selectedStoredAccountZesa"
                    @input="populateFromStoredAccount"
                    :options="storedAccounts.filter(acc => acc.account_type === 'ZESA')"
                    label="account_name"
                    placeholder="Search or select an account">
                </v-select>
            </div>

            <div v-if="form.zesa.length" class="table-responsive">

                <table class="table table-vcenter table-bordered rounded">
                    <thead>
                    <tr>
                        <th style="width: 25%">Account</th>
                        <th>Meter Number</th>
                        <th>Phone</th>
                        <th>Amount</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(item , key) in form.zesa" >
                        <tr :key="`zesa-${key}`">
                            <th class="d-flex flex-column" >
                                <span class="row-text">{{ form.zesa[key].account || '---' }}</span>
                                <small>{{ form.zesa[key].group ==='null' ? '---' : form.zesa[key].group || '---' }}</small>
                            </th>
                            <th>

                                <input v-model="form.zesa[key].meter"
                                       type="number"
                                       @keyup="addNewFieldRow('zesa', key)"
                                       :class="['form-control form-control-sm' , form.errors.get(`zesa.${key}.meter`) ? 'is-invalid' : '' ]"/>
                                <div
                                    v-text="form.errors.get(`zesa.${key}.meter`) ? form.errors.get(`zesa.${key}.meter`).replace(`zesa.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <input v-model="form.zesa[key].phone" type="number"
                                       :class="['form-control form-control-sm' , form.errors.get(`zesa.${key}.phone`) ? 'is-invalid' : '' ]"/>
                                <div
                                    v-text="form.errors.get(`zesa.${key}.phone`) ? form.errors.get(`zesa.${key}.phone`).replace(`zesa.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <input v-model="form.zesa[key].amount" type="number"
                                       :class="['form-control form-control-sm' , form.errors.get(`zesa.${key}.amount`) ? 'is-invalid' : '' ]"/>
                                <div
                                    v-text="form.errors.get(`zesa.${key}.amount`) ? form.errors.get(`zesa.${key}.amount`).replace(`zesa.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <button @click="form.zesa.push({meter : '', phone : '', amount : ''})"
                                            class="btn btn-outline-dark shadow-none btn-sm btn-extra-small mx-1">
                                        <i class="fa fa-plus-circle"></i>
                                    </button>
                                    <button @click="remove('zesa' , key)"
                                            class="btn btn-outline-danger btn-sm btn-extra-small shadow-none mx-1">
                                        <i class="fa fa-trash"></i></button>
                                </div>
                            </th>
                        </tr>
                        <tr :key="`zesa-errors-${key}`" v-if="item.errors && item.errors.length > 0">
                            <td></td>
                            <td colspan="4">
                                <i class="fa fa-exclamation-triangle"></i>
                                {{ Object.values(item.errors).join(', ') }}
                            </td>
                        </tr>
                    </template>
                    </tbody>
                    <tr>
                        <th>Quantity</th>
                        <th>{{ form.zesa.length }}</th>
                        <th>Zesa Total</th>
                        <th>
                            {{ methods[form.payment] }} {{
                                form.zesa.map(mapAmount).reduce(sum, 0).toFixed(2)
                            }}
                        </th>
                        <th></th>
                    </tr>
                </table>
            </div>
        </div>

        <!-- Airtime ============================-->
        <div class="card-body border-bottom"  v-if="methods[form.payment] === 'ZWG'">
            <div class="d-flex align-items-center" :class="{ 'mb-3': form.airtime.length }">
                <div class="mr-auto text-4">
                    Econet ZWG Airtime
                </div>
                <div>
                    <div v-if="!systems.corp_econet_zig || !canBuyEconetZwg" class="bg-danger rounded text-white text-center text-1 mt-n1 px-2">
                        <strong>NOTE:</strong> {{ 'This service is unavailable at the moment. Please try again later.' }}
                    </div>
                    <button v-else  @click="form.airtime.push({phone : '',amount : ''})"
                            class="btn btn-success shadow-none btn-sm btn-extra-small mx-1">
                        <i class="fa fa-plus-circle"></i>
                        <small>Add Row</small>
                    </button>
                </div>
            </div>

            <div class="form-group" v-if="canBuyEconetZwg">
                <label>Select Stored Account(ECONET)</label>
                <v-select
                    v-model="selectedStoredAccountAirtime"
                    @input="populateFromStoredAccount"
                    :options="storedAccounts.filter(acc => acc.account_type === 'ECONET')"
                    label="account_name"
                    placeholder="Search or select an account">
                </v-select>
            </div>

            <div v-if="form.airtime.length" class="table-responsive">
                <table class="table table-vcenter table-bordered rounded">
                    <thead>
                    <tr>
                        <th style="width: 25%">Account</th>
                        <th>Phone</th>
                        <th>Amount</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item , key) in form.airtime" :key="`airtime-${key}`">
                        <th class="d-flex flex-column" >
                            <span class="row-text">{{ form.airtime[key].account || '---' }}</span>
                            <small>{{ form.airtime[key].group || '---' }}</small>
                        </th>
                        <th>
                            <input v-model="form.airtime[key].phone" type="number"
                                   @keyup="addNewFieldRow('airtime', key)"
                                   :class="['form-control form-control-sm' , form.errors.get(`airtime.${key}.phone`) ? 'is-invalid' : '' ]"/>
                            <div
                                v-text="form.errors.get(`airtime.${key}.phone`) ? form.errors.get(`airtime.${key}.phone`).replace(`airtime.${k}.`,'') : ''"
                                class="invalid-feedback"/>
                        </th>
                        <th>
                            <input v-model="form.airtime[key].amount" type="number"
                                   :class="['form-control form-control-sm' , form.errors.get(`zesa.${key}.amount`) ? 'is-invalid' : '' ]"/>
                            <div
                                v-text="form.errors.get(`airtime.${key}.amount`) ? form.errors.get(`airtime.${key}.amount`).replace(`airtime.${k}.`,'') : ''"
                                class="invalid-feedback"/>
                        </th>
                        <th>
                            <div class="d-flex">
                                <button @click="form.airtime.push({phone : '', amount : ''})"
                                        class="btn btn-outline-dark shadow-none btn-sm btn-extra-small mx-1">
                                    <i class="fa fa-plus-circle"></i>
                                </button>
                                <button @click="remove('airtime' , key)"
                                        class="btn btn-outline-danger btn-sm btn-extra-small shadow-none mx-1">
                                    <i class="fa fa-trash"></i></button>
                            </div>
                        </th>
                    </tr>
                    </tbody>
                    <tr>
                        <th>Quantity</th>
                        <th>{{ form.airtime.length }}</th>
                        <th>Airtime Total</th>
                        <th>
                            {{ methods[form.payment] }} {{
                                form.airtime.map(mapAmount).reduce(sum, 0).toFixed(2)
                            }}
                        </th>
                    </tr>
                </table>
            </div>
        </div>

        <!-- Econet Bundles ============================-->
        <div class="card-body border-bottom" v-if="methods[form.payment] === 'ZWG'">
            <div class="d-flex align-items-center" :class="{ 'mb-3': form.bundle.length }">
                <div class="mr-auto text-4">
                    Econet Bundle
                </div>
                <div>
                    <div v-if="!systems.corp_econet_zig || !canBuyEconetZwg" class="bg-danger rounded text-white text-center text-1 mt-n1 px-2">
                        <strong>NOTE:</strong> {{ 'This service is unavailable at the moment. Please try again later.' }}
                    </div>
                    <button v-else @click="form.bundle.push({phone : '',bundle : '' , amount : ''})"
                            class="btn btn-success shadow-none btn-sm btn-extra-small mx-1">
                        <i class="fa fa-plus-circle"></i>
                        <small>Add Row</small>
                    </button>
                </div>
            </div>

            <div class="form-group" v-if="canBuyEconetZwg">
                <label>Select Stored Account(ECONET)</label>
                <v-select
                    v-model="selectedStoredAccountBundle"
                    @input="populateFromStoredAccount"
                    :options="storedAccounts.filter(acc => acc.account_type === 'ECONET')"
                    label="account_name"
                    placeholder="Search or select an account">
                </v-select>
            </div>

            <div v-if="form.bundle.length" class="table-responsive">
                <table class="table table-vcenter table-bordered rounded">
                    <thead>
                    <tr>
                        <th style="width: 25%">Account</th>
                        <th>Bundle</th>
                        <th>Phone</th>
                        <th>Amount</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item , key) in form.bundle" :key="`bundle-${key}`">
                        <th class="d-flex flex-column" >
                            <span class="row-text">{{ form.bundle[key].account || '---' }}</span>
                            <small>{{ form.bundle[key].group || '---' }}</small>
                        </th>
                        <th>
                            <select :key="`bundle-select-${key}`" @change="gbundle('bundle' , key)"
                                    v-model="form.bundle[key].bundle" type="text"
                                    :class="['form-control form-control-sm' , form.errors.get(`bundle.${key}.bundle`) ? 'is-invalid' : '' ]">
                                <option value="">Choose Bundle</option>
                                <option v-for="i in bundles" :value="i.id">ZWG {{ i.price }} : {{
                                        i.description
                                    }}
                                </option>
                            </select>
                            <div
                                v-text="form.errors.get(`bundle.${key}.bundle`) ? form.errors.get(`bundle.${key}.bundle`).replace(`bundle.${k}.`,'') : ''"
                                class="invalid-feedback"/>
                        </th>
                        <th>
                            <input v-model="form.bundle[key].phone" type="number"
                                   :class="['form-control form-control-sm' , form.errors.get(`bundle.${key}.phone`) ? 'is-invalid' : '' ]"/>
                            <div
                                v-text="form.errors.get(`bundle.${key}.phone`) ? form.errors.get(`bundle.${key}.phone`).replace(`bundle.${k}.`,'') : ''"
                                class="invalid-feedback"/>
                        </th>
                        <th>
                            <span> {{ form.bundle[key].amount }}</span>
                        </th>
                        <th>
                            <div class="d-flex">
                                <button @click="form.bundle.push({phone : '', amount : ''})"
                                        class="btn btn-outline-dark shadow-none btn-sm btn-extra-small mx-1">
                                    <i class="fa fa-plus-circle"></i>
                                </button>
                                <button @click="remove('bundle' , key)"
                                        class="btn btn-outline-danger btn-sm btn-extra-small shadow-none mx-1">
                                    <i class="fa fa-trash"></i></button>
                            </div>
                        </th>
                    </tr>
                    </tbody>
                    <tr>
                        <th>Quantity</th>
                        <th>{{ form.bundle.length }}</th>
                        <th colspan="2">Bundle Total</th>
                        <th>
                            {{ methods[form.payment] }} {{
                                form.bundle.map(mapAmount).reduce(sum, 0).toFixed(2)
                            }}
                        </th>
                    </tr>
                </table>
            </div>
        </div>

        <template v-if="methods[form.payment] === 'USD'">
            <div class="card-body border-bottom">
                <div class="d-flex align-items-center" :class="{ 'mb-3': form.airtimeEco.length }">
                    <div class="mr-auto text-4">
                        Econet Airtime
                    </div>
                    <div>
                        <button  @click="form.airtimeEco.push({phone : '',amount : ''})"
                                 class="btn btn-success shadow-none btn-sm btn-extra-small mx-1">
                            <i class="fa fa-plus-circle"></i>
                            <small>Add Row</small>
                        </button>
                    </div>
                </div>

                <div class="form-group" v-if="systems.corp_econet_usd">
                    <label>Select Stored Account(ECONET)</label>
                    <v-select
                        v-model="selectedStoredAccountEcoUSD"
                        @input="populateFromStoredAccount"
                        :options="storedAccounts.filter(acc => acc.account_type === 'ECONET')"
                        label="account_name"
                        placeholder="Search or select an account">
                    </v-select>
                </div>

                <div v-if="form.airtimeEco.length" class="table-responsive">
                    <table class="table table-vcenter table-bordered rounded">
                        <thead>
                        <tr>
                            <th style="width: 25%">Account</th>
                            <th>Phone</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item , key) in form.airtimeEco" :key="`airtimeEco-${key}`">
                            <th class="d-flex flex-column" >
                                <span class="row-text">{{ form.airtimeEco[key].account || '---' }}</span>
                                <small>{{ form.airtimeEco[key].group || '---' }}</small>
                            </th>
                            <th>
                                <input v-model="form.airtimeEco[key].phone" type="number"
                                       @keyup="addNewFieldRow('airtimeEco', key)"
                                       :class="['form-control form-control-sm' , form.errors.get(`airtimeEco.${key}.phone`) ? 'is-invalid' : '' ]"/>
                                <div
                                    v-text="form.errors.get(`airtimeEco.${key}.phone`) ? form.errors.get(`airtimeEco.${key}.phone`).replace(`airtimeEco.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <input v-model="form.airtimeEco[key].amount" type="number"
                                       :class="['form-control form-control-sm' , form.errors.get(`airtimeEco.${key}.amount`) ? 'is-invalid' : '' ]"/>
                                <div
                                    v-text="form.errors.get(`airtimeEco.${key}.amount`) ? form.errors.get(`airtimeEco.${key}.amount`).replace(`airtimeEco.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <button @click="form.airtimeEco.push({phone : '', amount : ''})"
                                            class="btn btn-outline-dark shadow-none btn-sm btn-extra-small mx-1">
                                        <i class="fa fa-plus-circle"></i>
                                    </button>
                                    <button @click="remove('airtimeEco' , key)"
                                            class="btn btn-outline-danger btn-sm btn-extra-small shadow-none mx-1">
                                        <i class="fa fa-trash"></i></button>
                                </div>
                            </th>
                        </tr>
                        </tbody>
                        <tr>
                            <th></th>
                            <th>Airtime Total</th>
                            <th>
                                {{ methods[form.payment] }} {{
                                    form.airtimeEco.map(mapAmount).reduce(sum, 0).toFixed(2)
                                }}
                            </th>
                            <th></th>
                        </tr>
                    </table>
                </div>
            </div>
            <!-- Econet Smart Bundles ============================-->
            <div class="card-body border-bottom">
                <div class="d-flex align-items-center" :class="{ 'mb-3': form.smart.length }">
                    <div class="mr-auto text-4">
                        Econet Smart Bundle
                    </div>
                    <div>
                        <div v-if="!systems.corp_econet_usd" class="bg-danger rounded text-white text-center text-1 mt-n1 px-2">
                            <strong>NOTE:</strong> {{ 'This service is unavailable at the moment. Please try again later.' }}
                        </div>
                        <button v-else @click="form.smart.push({phone : '',bundle : '' , amount : ''})"
                                class="btn btn-success shadow-none btn-sm btn-extra-small mx-1">
                            <i class="fa fa-plus-circle"></i>
                            <small>Add Row</small>
                        </button>
                    </div>
                </div>

                <div class="form-group" v-if="systems.corp_econet_usd">
                    <label>Select Stored Account(ECONET)</label>
                    <v-select
                        v-model="selectedStoredAccountEcoUSDBundle"
                        @input="populateFromStoredAccount"
                        :options="storedAccounts.filter(acc => acc.account_type === 'ECONET')"
                        label="account_name"
                        placeholder="Search or select an account">
                    </v-select>
                </div>

                <div v-if="form.smart.length" class="table-responsive">
                    <table class="table table-vcenter table-bordered rounded">
                        <thead>
                        <tr>
                            <th style="width: 25%">Account</th>
                            <th>Bundle</th>
                            <th>Phone</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item , key) in form.smart" :key="`smart-${key}`">
                            <th class="d-flex flex-column" >
                                <span class="row-text">{{ form.smart[key].account || '---' }}</span>
                                <small>{{ form.smart[key].group || '---' }}</small>
                            </th>
                            <th>
                                <select :key="`smart-select-${key}`" @change="gbundle('smart' , key)"
                                        v-model="form.smart[key].bundle" type="text"
                                        :class="['form-control form-control-sm' , form.errors.get(`smart.${key}.bundle`) ? 'is-invalid' : '' ]">
                                    <option value="">Choose Bundle</option>
                                    <option v-for="i in smart" :value="i.id"> USD {{ i.price }} : {{
                                            i.description
                                        }}
                                    </option>
                                </select>
                                <div
                                    v-text="form.errors.get(`smart.${key}.bundle`) ? form.errors.get(`smart.${key}.bundle`).replace(`smart.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <input v-model="form.smart[key].phone" type="number"
                                       :class="['form-control form-control-sm' , form.errors.get(`smart.${key}.phone`) ? 'is-invalid' : '' ]"/>
                                <div
                                    v-text="form.errors.get(`smart.${key}.phone`) ? form.errors.get(`smart.${key}.phone`).replace(`smart.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <span> {{ form.smart[key].amount }}</span>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <button @click="form.smart.push({phone : '', amount : ''})"
                                            class="btn btn-outline-dark shadow-none btn-sm btn-extra-small mx-1">
                                        <i class="fa fa-plus-circle"></i>
                                    </button>
                                    <button @click="remove('smart' , key)"
                                            class="btn btn-outline-danger btn-sm btn-extra-small shadow-none mx-1">
                                        <i class="fa fa-trash"></i></button>
                                </div>
                            </th>
                        </tr>
                        </tbody>
                        <tr>
                            <th>Quantity</th>
                            <th>{{ form.smart.length }}</th>
                            <th colspan="2">Smart Total</th>
                            <th>
                                {{ methods[form.payment] }} {{
                                    form.smart.map(mapAmount).reduce(sum, 0).toFixed(2)
                                }}
                            </th>

                        </tr>
                    </table>
                </div>
            </div>

            <!-- Netone Bundles ============================-->
            <div class="card-body border-bottom">
                <div class="d-flex align-items-center" :class="{ 'mb-3': form.netone.length }">
                    <div class="mr-auto text-4">
                        NetOne Bundle
                    </div>

                    <div>
                        <div v-if="!systems.corp_netone_usd" class="bg-danger rounded text-white text-center text-1 mt-n1 px-2">
                            <strong>NOTE:</strong> {{ 'This service is unavailable at the moment. Please try again later.' }}
                        </div>
                        <button v-else @click="form.netone.push({phone : '',bundle : '' , amount : ''})"
                                class="btn btn-success shadow-none btn-sm btn-extra-small mx-1">
                            <i class="fa fa-plus-circle"></i>
                            <small>Add Row</small>
                        </button>
                    </div>
                </div>

                <div class="form-group" v-if="systems.corp_netone_usd">
                    <label>Select Stored Account(NETONE)</label>
                    <v-select
                        v-model="selectedStoredAccountNetone"
                        @input="populateFromStoredAccount"
                        :options="storedAccounts.filter(acc => acc.account_type === 'NETONE')"
                        label="account_name"
                        placeholder="Search or select an account">
                    </v-select>
                </div>

                <div v-if="form.netone.length" class="table-responsive">
                    <table class="table table-vcenter table-bordered rounded">
                        <thead>
                        <tr>
                            <th style="width: 25%">Account</th>
                            <th>Bundle</th>
                            <th>Phone</th>
                            <th>Amount</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item , key) in form.netone" :key="`netone-${key}`">
                            <th class="d-flex flex-column" >
                                <span class="row-text">{{ form.netone[key].account || '---' }}</span>
                                <small>{{ form.netone[key].group || '---' }}</small>
                            </th>
                            <th>
                                <select :key="`netone-select-${key}`" @change="gbundle('netone' , key)"
                                        v-model="form.netone[key].bundle" type="text"
                                        :class="['form-control form-control-sm' , form.errors.get(`netone.${key}.bundle`) ? 'is-invalid' : '' ]">
                                    <option value="">Choose Bundle</option>
                                    <option v-for="i in netone" :value="i.id"> USD {{ i.price }} : {{
                                            i.description
                                        }}
                                    </option>
                                </select>
                                <div
                                    v-text="form.errors.get(`netone.${key}.bundle`) ? form.errors.get(`netone.${key}.bundle`).replace(`netone.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <input v-model="form.netone[key].phone" type="number"
                                       :class="['form-control form-control-sm' , form.errors.get(`netone.${key}.phone`) ? 'is-invalid' : '' ]"/>
                                <div
                                    v-text="form.errors.get(`netone.${key}.phone`) ? form.errors.get(`netone.${key}.phone`).replace(`netone.${k}.`,'') : ''"
                                    class="invalid-feedback"/>
                            </th>
                            <th>
                                <span> {{ form.netone[key].amount }}</span>
                            </th>
                            <th>
                                <div class="d-flex">
                                    <button @click="form.netone.push({phone : '', amount : ''})"
                                            class="btn btn-outline-dark shadow-none btn-sm btn-extra-small mx-1">
                                        <i class="fa fa-plus-circle"></i>
                                    </button>
                                    <button @click="remove('netone' , key)"
                                            class="btn btn-outline-danger btn-sm btn-extra-small shadow-none mx-1">
                                        <i class="fa fa-trash"></i></button>
                                </div>
                            </th>
                        </tr>
                        </tbody>
                        <tr>
                            <th>Quantity</th>
                            <th>{{ form.netone.length }}</th>
                            <th colspan="2">NetOne Total</th>
                            <th>
                                {{ methods[form.payment] }} {{
                                    form.netone.map(mapAmount).reduce(sum, 0).toFixed(2)
                                }}
                            </th>

                        </tr>
                    </table>
                </div>
            </div>
        </template>

        <div class="card-footer text-center">
            <button @click="submit" :class="{'btn-loading': loading}" class="btn btn-success btn-block shadow-none mb-2">
                <i class="fa fa-check"></i> Submit Transaction
            </button>
            <router-link to="/business/transact" class="btn btn-link shadow-none">
                Start Again?
            </router-link>
        </div>
    </div>
</template>
<style scoped>

.row-text{
    font-size: 0.75rem;
    color: #252c65;
}
.btn-extra-small {
    padding: 6px 6px;
    font-size: 12px;
    line-height: 1.2;
}
</style>
